import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { BaseTypography } from '../BaseTypography/BaseTypography';
import clsx from 'clsx';

export const horizontalPadding = '20px';

const useStyles = makeStyles(() => ({
  card: {
    // border: '1px solid #EDEDED',
    borderTop: '1px solid #E5E7EB',
    boxSizing: 'border-box',
    // borderRadius: '4px',
    background: '#ffffff',
  },
  card__header: {
    background: '#7AC5F1',
    borderRadius: '0',
    display: 'flex',
    alignItems: 'center',
    // minHeight: '40px',
    padding: '12px 24px',
    color: 'white',
    // padding: `0 ${horizontalPadding}`,
  },
  card__body: {
    padding: `0`,
  },
}));

type PBaseTableContainer = {
  title: string | React.ElementType;
  style?: any;
  bodyClassName?: any;
  bodyStyles?: any;
};

export const BaseTableCard: React.FC<PBaseTableContainer> = (props) => {
  const classes = useStyles();
  const { title, children, style = {}, bodyClassName, bodyStyles = {} } = props;
  return (
    <div className={classes.card} style={style}>
      <div className={classes.card__header}>
        <BaseTypography variant="textMedium">
          <span>+</span>
          <span> {title}</span>
        </BaseTypography>
      </div>
      <div
        className={clsx(classes.card__body, bodyClassName)}
        style={bodyStyles}
      >
        {children}
      </div>
    </div>
  );
};
